export const size = {
	middle: `col-span-4  md:col-span-4 lg:col-span-4 2xl:col-span-4`,
	left: `col-span-4  md:col-span-4 lg:col-span-4 2xl:col-span-4`,
	right: `col-span-2  md:col-span-2 lg:col-span-2 2xl:col-span-2`,
};
